@use '../../scss/utility/functions' as utility;

:host {
  --focus-color: var(--wb-blue-50);

  display: inline-flex;
  align-items: center;
}

:host([theme='dark']) {
  --focus-color: var(--wb-blue-45);
}

:host([direction='horizontal']) {
  flex-direction: row;
}

:host([direction='vertical']) {
  flex-direction: column;
  align-items: stretch;
}

:host([direction='horizontal']) ::slotted(.wb-button:not(:first-child)) {
  margin-inline-start: utility.wb-pixel-to-rem(-1px);
}

:host([direction='vertical']) ::slotted(.wb-button:not(:first-child)) {
  margin-block-start: utility.wb-pixel-to-rem(-1px);
}

:host([direction='vertical']) ::slotted(.wb-button:not(:last-child)) {
  --border-block-end-right-radius: 0;
  --border-block-end-left-radius: 0;
}

:host([direction='vertical']) ::slotted(.wb-button:not(:first-child)) {
  --border-block-start-right-radius: 0;
  --border-block-start-left-radius: 0;
}

:host([direction='horizontal']) ::slotted(.wb-button:not(:last-child)) {
  --border-block-start-right-radius: 0;
  --border-block-end-right-radius: 0;
}

:host([direction='horizontal']) ::slotted(.wb-button:not(:first-child)) {
  --border-block-start-left-radius: 0;
  --border-block-end-left-radius: 0;
}
